/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ReferencingObjectDto
 */
export interface ReferencingObjectDto {
    /**
     * 
     * @type {string}
     * @memberof ReferencingObjectDto
     */
    entityTypeName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReferencingObjectDto
     */
    entityName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReferencingObjectDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReferencingObjectDto
     */
    $type?: ReferencingObjectDtoTypeEnum;
}


/**
 * @export
 */
export const ReferencingObjectDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoIsReferencedReferencingObjectDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.IsReferenced.ReferencingObjectDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ReferencingObjectDtoTypeEnum = typeof ReferencingObjectDtoTypeEnum[keyof typeof ReferencingObjectDtoTypeEnum];


/**
 * Check if a given object implements the ReferencingObjectDto interface.
 */
export function instanceOfReferencingObjectDto(value?: unknown): value is ReferencingObjectDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ReferencingObjectDtoTypeEnum)[0];
}

export function ReferencingObjectDtoFromJSON(json: any): ReferencingObjectDto {
    return ReferencingObjectDtoFromJSONTyped(json, false);
}

export function ReferencingObjectDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferencingObjectDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityTypeName': !exists(json, 'entityTypeName') ? undefined : json['entityTypeName'],
        'entityName': !exists(json, 'entityName') ? undefined : json['entityName'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ReferencingObjectDtoToJSON(value?: ReferencingObjectDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'entityTypeName': value.entityTypeName,
        'entityName': value.entityName,
        'iuid': value.iuid,
        '$type': value.$type,
    });
}

